var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _c("br"),
      _c(
        "el-row",
        { attrs: { gutter: 0 } },
        [
          _c("el-input", {
            attrs: { type: "textarea", rows: 10 },
            model: {
              value: _vm.value,
              callback: function ($$v) {
                _vm.value = $$v
              },
              expression: "value",
            },
          }),
        ],
        1
      ),
      _c("br"),
      _vm._m(1),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("p", [_vm._v('说明：“/"的个数表示层级数，最多支持4级')]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticStyle: { "font-size": "12px", color: "#979797" } },
      [
        _vm._v(" 示例： "),
        _c("div", [
          _vm._v(" 选项1 "),
          _c("br"),
          _vm._v(" 选项1/选项1-1 "),
          _c("br"),
          _vm._v(" 选项1/选项1-1/选项1-1-1 "),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }